import { CommonModule } from '@angular/common'
import {
  ChangeDetectorRef,
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  HostListener,
  OnInit,
} from '@angular/core'
import { MatDialog, MatDialogConfig } from '@angular/material/dialog'
import { RouterModule } from '@angular/router'
import { Store } from '@ngrx/store'
import { InfiniteScrollDirective } from 'ngx-infinite-scroll'
import { AnimationOptions } from 'ngx-lottie'
import { Observable } from 'rxjs'
import { AngularMaterialsModules } from 'src/app/module/materials.module'
import { AppState } from 'src/app/ngrx/states'
import { getTheme } from 'src/app/ngrx/store/selectors'
import { AuthUserService } from 'src/app/service/auth/auth-user.service'
import { DdcLoggerService } from 'src/app/service/log/ddc-logger.service'
import { HomeStateService } from 'src/app/service/state/home-state.service'
import { UserService } from 'src/app/service/user-info/user.service'
import { DdcContentCardComponent } from 'src/app/shared/ddc/ddc-content-card/ddc-content-card.component'
import { DdcDeleteDialogComponent } from 'src/app/shared/ddc/ddc-delete-dialog/ddc-delete-dialog.component'
import { DdcDesktopDialogComponent } from 'src/app/shared/ddc/ddc-desktop-dialog/ddc-desktop-dialog.component'
import { DdcMobileSheetComponent } from 'src/app/shared/ddc/ddc-mobile-sheet/ddc-mobile-sheet.component'
import { ContentTypes, DefaultPagination } from 'src/app/shared/enums/enums'
import { HomeElem } from 'src/app/shared/models/main/home-elem'
import { five_lines_dummy_text, multiline_dummy_text } from '../../dummy/dummies'
import { DdcDashboardCardComponent } from '../../shared/ddc/ddc-dashboard-card/ddc-dashboard-card.component'
import { DdcExploredCardsComponent } from '../../shared/ddc/ddc-explored-cards/ddc-explored-cards.component'
import { DdcLoadingSkeletonComponent } from '../../shared/ddc/ddc-loading-skeleton/ddc-loading-skeleton.component'
import { DdcNotAvailableComponent } from '../../shared/ddc/ddc-not-available/ddc-not-available.component'
import { DdcUpgradeCardComponent } from '../../shared/ddc/ddc-upgrade-card/ddc-upgrade-card.component'
import { DeleteWordPairDicCommand } from '../commands/delete-word-pair-dic/delete-word-pair-dic.command'

@Component({
  selector: 'ddc-home',
  templateUrl: './ddc-home.component.html',
  styleUrls: ['./ddc-home.component.scss'],
  imports: [
    AngularMaterialsModules,
    CommonModule,
    RouterModule,
    DdcDashboardCardComponent,
    DdcLoadingSkeletonComponent,
    InfiniteScrollDirective,
    DdcNotAvailableComponent,
    DdcContentCardComponent,
    DdcExploredCardsComponent,
    DdcUpgradeCardComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class DdcHomeComponent implements OnInit {
  _multiline_dummy_text: string = multiline_dummy_text
  _fivelines_dummy_text: string = five_lines_dummy_text
  _userPofileInfo: any
  _isMobile: boolean = false
  _theme$: Observable<string>

  _elems: HomeElem[] = []
  _elemsCurrentPage = 1
  _elemsPerPage = DefaultPagination.OBJECT_PER_PAGE
  _isElemsLoading: boolean = false
  _isElemsLoaded: boolean = false

  _isElemsPgnLoading: boolean = false
  _elemsPageInfoLabel = 'Scroll down to load more'
  _elemsScrollLoading = false
  _elemsEnd = false
  _fetchElemsError: string = 'Empty.'
  _isElemsEmpty: boolean = false
  _nElems: number

  scroll_options: AnimationOptions = {
    path: '/assets/lottie/scroll_down.json',
    loop: true, // Set loop to false for a single playthrough
    autoplay: true,
  }

  loading_options: AnimationOptions = {
    path: '/assets/lottie/loading2.json',
    loop: true, // Set loop to false for a single playthrough
    autoplay: true,
  }

  _ads: any = [
    {
      title: 'a1',
      subtitle: 'a2',
      content: 'a3',
      img: '"https://material.angular.io/assets/img/examples/shiba2.jpg"',
    },
    {
      title: 'b1',
      subtitle: 'b2',
      content: 'b3',
      img: '"https://material.angular.io/assets/img/examples/shiba2.jpg"',
    },
    {
      title: 'c1',
      subtitle: 'c2',
      content: 'c3',
      img: '"https://material.angular.io/assets/img/examples/shiba2.jpg"',
    },
  ]

  constructor(
    private cdr: ChangeDetectorRef,
    private logger: DdcLoggerService,
    private store: Store<AppState>,
    public auth_service: AuthUserService,
    private homeState: HomeStateService,
    public user_service: UserService,
    public dialog: MatDialog,
    private deleteWordPairDicCommand: DeleteWordPairDicCommand,
  ) {
    this._theme$ = this.store.select(getTheme)
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any): void {
    this._isMobile = event.target.innerWidth < 1224
  }

  checkIfMobile(): void {
    if (window.innerWidth < 500) {
      // 768px is a common breakpoint for mobile devices
      this._isMobile = true
    } else {
      this._isMobile = false
    }
  }

  ngOnInit(): void {
    this.checkIfMobile()

    // Subscribe to library state
    this.homeState.items$.subscribe(items => {
      this._elems = items
      // Only update the latest item if we have items
      this.cdr.detectChanges()
    })

    // Subscribe to total items to keep overview in sync
    this.homeState.totalItems$.subscribe(totals => {
      // Update both overview and list counts
      this._nElems = totals.items

      // Force change detection to update the view
      this.cdr.detectChanges()
    })

    this.getDashboardInfo()
    if (!this._isElemsLoaded) {
      this.clearElemsParameters()
    }

    if (!this._isElemsLoaded) {
      this.getElemsPage()
    }
  }

  clearElemsParameters(): void {
    this._elemsCurrentPage = 1
  }

  toggleElemsPaginationLoading = (): void => {
    this.logger.info('DdcHomeComponent | toggleElemsPaginationLoading()')
    this._isElemsPgnLoading = !this._isElemsPgnLoading
  }

  onElemsScroll(): void {
    this.logger.info('DdcLibraryComponent | onDictionariesScroll()')
    this._elemsCurrentPage++
    this.appendElemsData()
  }

  appendElemsData = (): void => {
    this.logger.info('DdcHomeComponent | appendElemsData()')
    if (!this._elemsEnd) {
      this._elemsScrollLoading = true
      this._elemsPageInfoLabel = 'Loading...'
      this.homeState
        .loadMoreItems()
        .then(() => {
          this._elemsEnd = false
          this._elemsPageInfoLabel = 'Scroll down to load more'
          this._elemsScrollLoading = false
        })
        .catch(() => {
          this._elemsEnd = true
          this._elemsPageInfoLabel = 'No more items'
          this._elemsScrollLoading = false
          console.error('Error loading more items.')
        })
    }
  }

  getDashboardInfo(): void {
    this.logger.info('DdcHomeComponent | getDashboardInfo()')
    this.user_service.get_user_profile().subscribe((res: any) => {
      if (res) {
        setTimeout(() => {
          this._userPofileInfo = res
        }, 500) // two seconds
      }
    })
  }

  getElemsPage(): void {
    this.logger.info('DdcHomeComponent | getElemsPage()')
    this._isElemsLoading = true
    this._elemsScrollLoading = true
    this._elemsPageInfoLabel = 'Loading...'

    this.toggleElemsPaginationLoading()

    // Use the library state service
    this.homeState
      .loadItems(true)
      .then(() => {
        this._elemsEnd = false
        this._elemsPageInfoLabel = 'Scroll down to load more'
        this._isElemsLoading = false
        this._isElemsLoaded = true
        this.toggleElemsPaginationLoading()
      })
      .catch(error => {
        this.logger.error('Error loading elements:', error)
        this._elemsEnd = true
        this._isElemsEmpty = true
        this._fetchElemsError = error?.message || 'Failed to load elements'
        this._elemsPageInfoLabel = 'Error loading items'
        this._isElemsLoading = false
        this.toggleElemsPaginationLoading()
      })
  }

  private readonly CONTENT_TYPE_CONFIG: Record<
    string,
    { label: string; dialogKey: string; contentTypeId: number }
  > = {
    dictionary: { label: 'Dictionary', dialogKey: 'dictionary', contentTypeId: ContentTypes.DIC },
    note: { label: 'Note', dialogKey: 'note', contentTypeId: ContentTypes.NOTE },
    quiz: { label: 'Quiz', dialogKey: 'quiz', contentTypeId: ContentTypes.QUIZ },
    figure: { label: 'Figure', dialogKey: 'figure', contentTypeId: ContentTypes.FIGURE },
  }

  updateBookmark(event: any, index: number): void {
    this._elems[index].is_bookmarked = event
  }

  openReadDialog(index: number): void {
    const element = this._elems[index]
    const config = this.CONTENT_TYPE_CONFIG[element.type]
    if (!config) return
    const type = `read-${config.dialogKey}`
    if (this._isMobile) {
      this.dialog.open(DdcMobileSheetComponent, this.getMobileDialogConfig(type, element))
    } else {
      const dialogConfig = new MatDialogConfig()
      dialogConfig.width = '600px'
      dialogConfig.maxWidth = '90vw'
      dialogConfig.hasBackdrop = true
      dialogConfig.data = { type, element }
      this.dialog.open(DdcDesktopDialogComponent, dialogConfig)
    }
  }

  openEditDialog(index: number): void {
    const element = this._elems[index]
    const config = this.CONTENT_TYPE_CONFIG[element.type]
    if (!config) return
    const type = `edit-${config.dialogKey}`
    if (this._isMobile) {
      this.dialog.open(DdcMobileSheetComponent, this.getMobileDialogConfig(type, element))
    } else {
      const dialogConfig = new MatDialogConfig()
      dialogConfig.width = '600px'
      dialogConfig.maxWidth = '90vw'
      dialogConfig.hasBackdrop = true
      dialogConfig.data = { type, element }
      this.dialog.open(DdcDesktopDialogComponent, dialogConfig)
    }
  }

  openDeleteDialog(index: number): void {
    const element = this._elems[index]
    const config = this.CONTENT_TYPE_CONFIG[element.type]
    if (!config) return
    const dialogRef = this.dialog.open(DdcDeleteDialogComponent, {
      data: { type: config.label, element },
    })

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'delete-element') {
        this.deleteWordPairDicCommand.setArgs({
          content_type_id: config.contentTypeId,
          object_id: element.id,
        })
        this.deleteWordPairDicCommand.execute().subscribe(success => {
          if (success) {
            const idx = this._elems.findIndex(elem => elem.id === element.id)
            if (idx !== -1) {
              this._elems.splice(idx, 1)
              this.cdr.detectChanges()
            }
          }
        })
      }
    })
  }

  private getMobileDialogConfig(type: string, element: any): MatDialogConfig {
    let themeClass = ''
    this._theme$
      .subscribe(theme => {
        themeClass = theme
      })
      .unsubscribe()
    const config = new MatDialogConfig()
    config.panelClass = ['mobile-sheet-container', themeClass]
    config.position = { bottom: '0' }
    config.width = '100%'
    config.height = '80vh'
    config.maxWidth = '100vw'
    config.hasBackdrop = true
    config.backdropClass = 'mobile-sheet-backdrop'
    config.enterAnimationDuration = '300ms'
    config.exitAnimationDuration = '200ms'
    config.data = { type, element }
    return config
  }

  onUpgradeClicked(): void {
    // Handle upgrade button click
    // You can implement navigation to upgrade page or open upgrade dialog
    this.logger.info('Upgrade button clicked')
    // Example: this.router.navigate(['/upgrade'])
  }
}
